"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Articles;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _privacy = _interopRequireDefault(require("./privacy"));
var _terms = _interopRequireDefault(require("./terms"));
var _ParticipationStatement = _interopRequireDefault(require("./ParticipationStatement"));
var _notFound = _interopRequireDefault(require("../not-found"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _ref = /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  component: _notFound.default
});
function Articles({
  match: {
    path
  }
}) {
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/terms',
    component: _terms.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/privacy',
    component: _privacy.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/participation-statement',
    component: _ParticipationStatement.default
  }), _ref);
}